<div class="game-wrapper">
    <img [src]="shortGameInfo.logoUrl"
         class="game-icon">
    <span>{{shortGameInfo.displayName}}</span>
    <span>{{shortGameInfo.description}}</span>
    <span>{{shortGameInfo.players}}</span>
</div>
